<template> 
  <div class="projects">
    <div class="project">
      <div class="project_under_blocks">
        <div class="project_block">
          <div class="project_block_header">
            <span>Wallets</span> 
            <div class="sub_wallets_block">
              <p>Wallets Count: {{ this.preHeatedWalletCount }}</p>
              <div class="button" style="margin-top: 0; padding: 5px 1rem" @click="isShowArchiveBlock = true">
                <span style="font-size: 16px; font-family: 'Proxima Nova'">Архив</span>
              </div>
              <div class="button" style="margin-top: 0; padding: 5px 1rem" @click="returnFee">Return creator fee ({{this.creatorFee}} SOL)</div>
              <div class="button" style="margin-top: 0; padding: 5px 1rem" :style="highlightUnused ? 'background-color: #b159ff;' : ''" @click="highlightUnused = !highlightUnused">
                <span style="font-size: 16px; font-family: 'Proxima Nova'">Unused</span>
              </div>
              <div class="add_wallet" @click="isCreateWallet = !isCreateWallet">
                <span :class="isCreateWallet ? 'rotatePlus' : null">+</span>
              </div>
            </div>
            <div class="add_wallet_modal" v-if="isCreateWallet">
              <span class="project_block_mini_header">Count of Wallets</span>
              <div class="input medium">
                <input v-model="walCountCreate" type="number" placeholder="Enter count of wallets" />
              </div>
              <span class="project_block_mini_header">SOL Amount</span>
              <div class="input medium">
                <input v-model="solAmountCreate" type="text" placeholder="Enter SOL Amount" />
              </div>
              <button class="button" @click="createWallet">Create</button>
            </div>
          </div>
          <div class="project_block_wallets" v-if="wallets">
            <div class="project_block_wallet" :class="{ random: isRandomSelect }" @click="handlePickWalletRandom">
              <span style="font-family: 'Proxima Nova'">RANDOM</span>
              <span>BUYER</span>
            </div>
            <div class="project_block_wallet" v-for="i of wallets" :key="i" :class="[isSelected(i) ? 'selected' : '', getOwnershipClass(i), highlightUnused && !usedWallets.has(i.publicKey) ? 'wallet-unused' : '']" @click="handlePickWallet(i)" :id="i.id" @contextmenu.prevent="handleRightClickWallet">
              <span style="display: flex; align-items: center;">{{ i.publicKey.slice(-5) }} <span v-if="i.zeroblock" class="zeroblock-badge">0</span><img v-if="i.photon" style="width: 1em; height: 1em;" src="../assets/photonLogo.svg"/><img v-if="i.bullx" style="width: 1em; height: 1em;" src="../assets/bullx_wallet_logo.png"/><img v-if="i.axiom" style="width: 1em; height: 1em;" src="../assets/axiom_wallet_logo.png"/><img v-if="i.padre" style="width: 1em; height: 1em;" src="../assets/terminal.png"/><img v-if="i.gmgn" style="width: 1em; height: 1em;" src="../assets/gmgn.png"/></span>
              <span>{{ ((i.balanceSpl / 1e9) * 100).toFixed(4) }}%</span>
              <span>{{ Math.round(Number(i.balance) * 1000) / 1000 }} SOL</span>
            </div>
            <Transition name="fade">
              <div v-if="showContextMenuWallet" class="context-menu" :style="{ top: menuPosition.y + 'px', left: menuPosition.x + 'px' }">
                <!-- <button @click="changeNick">Сменить ник</button> -->
                <button @click="archiveWallet">В архив</button>
              </div>
            </Transition>
          </div>
        </div>

        <div class="project_block">
          <div class="project_block_header">
            <span>Project Accounts</span>
          </div>
          <div style="">
            <div class="projectInfo" style="grid-template-columns: 1fr">
              <div class="infoWallets" style="font-weight: bold">
                <p>SOL / Token Balance</p>
                <p></p>
                <p></p>
              </div>
            </div>
            <div class="projectInfo" style="grid-template-columns: 1fr">
              <div class="infoWallets" v-for="(item, index) in wallets" :key="item">
                <p>
                  {{ index + 1 }}.
                  {{ item.publicKey.slice(-5) }}
                </p>
                <p>{{ index + 1 == 1 ? "DEV KEY" : "KEY" }}</p>
                <p v-if="item.balance >= 0 && item.balanceSpl >= 0">
                  {{ item.balance.toFixed(3) }} SOL / {{ item.balanceSpl.toFixed(2) }}
                  {{ selectedToken.symbol }}
                </p>
              </div>
            </div>
            <div class="projectInfo" style="grid-template-columns: 1fr">
              <div class="infoWallets" style="font-weight: bold">
                <p></p>
                <p></p>
                <p>
                  TOTAL:<br />{{ totalSOLBalance }} SOL /
                  {{ totalSPLBalance }}
                  {{ selectedToken.symbol }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project_under_blocks">
        <div class="project_block">
          <div class="project_block_header">
            <span>Finance</span>
            <div class="jito_tip">
              <span class="jito_tip_text">Jito Tip</span>
              <div class="input">
                <input type="text" value="0.0005" v-model="jitoTip" />
                <span>SOL</span>
              </div>
            </div>
            
          </div>
          <span class="project_block_mini_header">Slippage (in %)</span>
            <div class="input medium">
              <input v-model="slippageBuy" type="text" placeholder="Enter buy slippage" />
            </div>
          <div class="project_block_finance">
            <div class="buttons" style="justify-content: space-between; align-items: center">
              <span class="project_block_mini_header">Buy</span>
              <div class="button" style="font-size: 14px; margin: 0; padding: 4px 20px" @click="editTemplate">
                {{ isEditTemplate ? "Save" : "Edit template" }}
              </div>

              <div class="edit_template_buy" v-if="isEditTemplate">
                <button v-for="(i, index) of solAmountBuyTemplatesNew" :key="index">
                  <input v-model="solAmountBuyTemplatesNew[index]" />
                </button>
              </div>
            </div>
            <div class="input medium">
              <input v-model="solAmountBuy" type="text" placeholder="Enter buy amount" @input="solAmountBuyRandom = solAmountBuy" />
              <span>{{ solAmountBuyRandom }}</span>
            </div>
            <div class="placeholder_buy">
              <div class="buy_placeholder_block" v-for="i of solAmountBuyTemplates" :key="i" @click="(solAmountBuy = i), generateRandomSum(solAmountBuy)">
                {{ i }}
              </div>
            </div>
                
                <div class="switch-container">
                  <p>Return: </p>
                  <label class="ios-switch">
                    <input type="checkbox" v-model="withReturn" />
                    <span class="slider"></span>
                  </label>
                </div>
            <button class="button" @click="buyToAccount">Buy</button>
            <div class="sell_block">
              <span class="project_block_mini_header">Sell</span>
              <span class="project_block_mini_header">{{ sellPercentSell }}%</span>
            </div>
            <Slider v-model="sellPercentSell" :tooltips="false" :min="1" :max="100" :lazy="false" />
            <div class="placeholder_buy">
                          <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 5;
                    sellTokens();
                  }
                "
              >
                5%
              </div>
                            <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 25;
                    sellTokens();
                  }
                "
              >
                10%
              </div>
              <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 25;
                    sellTokens();
                  }
                "
              >
                25%
              </div>
              <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 50;
                    sellTokens();
                  }
                "
              >
                50%
              </div>
              <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 75;
                    sellTokens();
                  }
                "
              >
                75%
              </div>
              <div
                class="buy_placeholder_block"
                @click="
                  () => {
                    sellPercentSell = 100;
                    sellTokens();
                  }
                "
              >
                100%
              </div>
            </div>
            <button class="button" @click="sellTokens">Sell</button>
          </div>
          <div class="project_block_finance">
            <span class="project_block_mini_header">Redeem SOL from selected wallets</span>
            <button class="button" @click="redeemSol">Redeem SOL</button>
          </div>
        </div>


        <div class="dex-chart">
          <div id="dexscreener-embed"><iframe :src="`https://dexscreener.com/solana/${this.selectedToken.mintPublicKey}?
?embed=1&loadChartSettings=0&tabs=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=1&chartType=usd&trades=0
&interval=1`"></iframe></div>
        </div>

        <div class="project_block">
          <div class="project_block_header">
            <span>Heat</span>
            <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="isShowHeatLogs = true" style="cursor: pointer">
              <path
                d="M15.6727 20.2547H2.33863C1.87797 20.2604 1.42613 20.1282 1.04117 19.8752C0.656201 19.6222 0.355691 19.2599 0.178243 18.8348C0.000794999 18.4097 -0.0454844 17.9413 0.0453502 17.4897C0.136185 17.0381 0.359984 16.624 0.687997 16.3005C1.17875 15.8211 1.56885 15.2486 1.83541 14.6165C2.10198 13.9844 2.23964 13.3054 2.24034 12.6194V9.663C2.2668 7.88782 2.99065 6.19431 4.25554 4.94831C5.52043 3.70232 7.22479 3.00388 9.00044 3.00388C10.7761 3.00388 12.4804 3.70232 13.7453 4.94831C15.0102 6.19431 15.7341 7.88782 15.7605 9.663V12.6209C15.7613 13.3068 15.899 13.9856 16.1656 14.6176C16.4322 15.2496 16.8222 15.822 17.3129 16.3013C17.64 16.6242 17.8633 17.0372 17.9543 17.4877C18.0453 17.9381 17.9998 18.4055 17.8237 18.83C17.6476 19.2545 17.3489 19.6168 16.9657 19.8706C16.5825 20.1244 16.1324 20.2581 15.6727 20.2547ZM9.00569 4.50105C8.8067 4.50105 8.61586 4.42201 8.47515 4.28133C8.33445 4.14064 8.2554 3.94983 8.2554 3.75087V0.750175C8.2554 0.551216 8.33445 0.360406 8.47515 0.219721C8.61586 0.079036 8.8067 0 9.00569 0C9.20468 0 9.39552 0.079036 9.53622 0.219721C9.67693 0.360406 9.75598 0.551216 9.75598 0.750175V3.75087C9.75598 3.94983 9.67693 4.14064 9.53622 4.28133C9.39552 4.42201 9.20468 4.50105 9.00569 4.50105ZM12.1869 21.7551C11.9534 22.4119 11.5222 22.9803 10.9526 23.3822C10.383 23.7842 9.70288 24 9.00569 24C8.3085 24 7.62841 23.7842 7.05881 23.3822C6.4892 22.9803 6.05802 22.4119 5.82447 21.7551H12.1869Z"
                fill="#60cb89"
              />
            </svg>
          </div>
          <div class="multi-select">
            <Multiselect v-model="selectedWalletHeat" select-label="" deselect-label="" limit="1" :options="wallets || []" label="wallet" track-by="id" :multiple="true" :close-on-select="false" placeholder="Please select wallet" @update:modelValue="(val) => console.log('modelValue updated:', val)">
              <template #option="{ option }">
                <div>{{ option.publicKey.slice(-5) }} - {{ option.balance >= 0 ? option.balance.toFixed(3) : null }} SOL</div>
              </template>
              <template #tag="{ option }">
                <span class="multiselect_tag">
                  {{ option.publicKey.slice(-5) || "Unnamed Wallet" }}
                </span>
              </template>
            </Multiselect>
            <div class="select_all" id="heat" @click="selectAllWallets($event, 'heat')">
              <img src="../assets/select_all.png" />
            </div>
          </div>
          <div class="inputs">
            <div class="input">
              <input type="text" v-model="minHeatAmount" placeholder="От скольки" />
              <span>$</span>
            </div>
            <div class="input">
              <input type="text" v-model="maxHeatAmount" placeholder="До скольки" />
              <span>$</span>
            </div>
          </div>
          <div class="buttons" style="justify-content: space-between">
            <button class="button" @click="heatWallets">Heat</button>
            <button class="button" style="padding: 7px 15px" @click="returnHeat">Return</button>
            <!-- <div class="loader" v-if="isHeatSpin">
              <div class="loader-fill"></div>
            </div> -->
          </div>
        </div>

          <div class="bump_bot">
          <div class="project_block">
            <div class="project_block_header">
              <span>Padre eyes</span>
              <div class="spread_bump_head">
                <button class="button" @click="getPadreEyesInfo">🔄</button>
              </div>
            </div>
            <div class="project_block_finance">
              <div class="project_data" v-if="selectedToken">
                <div class="info-labels">

                  <div>Eyes count</div>
                  <div class="input">
                    <input v-model="padreEyesCount" type="text" />
                    <span>👁️</span>
                  </div>
                  <div>Status</div>
                  <div>
                    {{ padreEyesStatus ? (padreEyesStatus ? "🟢 Started" : "🔴 Stopped") : "🔴 Stopped" }}
                  </div>
                  <div>Active accounts</div>
                  <div>{{ padreActiveAccounts }}</div>
                </div>
              </div>
              <div class="buttons_bump_block">
                <div class="buttons">
                  <button class="button" @click="startPadreEyes">Start</button>
                  <button class="button" @click="stopPadreEyes">Stop</button>
                </div>
                <button class="button" @click="updatePadreEyesBase">Save</button>
              </div>
            </div>
          </div>
        </div>


        <div class="bump_bot">
          <div class="project_block">
            <div class="project_block_header">
              <span>Bump Bot</span>
              <div class="spread_bump_head">
                <div class="input">
                  <input type="text" v-model="solAmountBump" />
                  <span>SOL</span>
                </div>
                <button class="button" @click="depositBumpWallet">Deposit</button>
              </div>
            </div>
            <div class="project_block_finance">
              <div class="project_data" v-if="selectedToken">
                <div class="info-labels">
                  <div>Select Mode</div>
                  <Multiselect v-model="bumpMode" select-label="" deselect-label="" limit="1" :options="['ONE', 'TWO', 'THREE']" :multiple="false" placeholder="Please select bump mode"> </Multiselect>
                  <div>Bump Amount</div>
                  <div class="input">
                    <input v-model="bumpAmount" type="text" />
                    <span>SOL</span>
                  </div>
                  <div>Burst Mode</div>
                  <div class="switch-container">
                    <label class="ios-switch">
                      <input type="checkbox" v-model="bumpBurst" />
                      <span class="slider"></span>
                    </label>
                  </div>
                  <div>Status</div>
                  <div>
                    {{ bumpInfo ? (bumpInfo.active ? "🟢 Started" : "🔴 Stopped") : "🔴 Stopped" }}
                  </div>
                  <div>Bump Wallet</div>
                  <p style="width: 100%">{{ bumpInfo ? bumpInfo.publicKey : "..." }}</p>
                  <div>Bump Balance</div>
                  <div>{{ bumpBalance >= 0 ? bumpBalance.toFixed(4) : null }} SOL</div>
                </div>
              </div>
              <div class="buttons_bump_block">
                <div class="buttons">
                  <button class="button" @click="startBumpBot">Start</button>
                  <button class="button" @click="stopBumpBot">Stop</button>
                </div>
                <button class="button" @click="returnBumpCash">Return</button>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="project_under_blocks">
        <div class="project_block">
          <div class="project_block_header">
            <span>Dump</span>
          </div>
          <div class="project_block_finance">
            <span class="project_block_mini_header">Dump Estimate</span>
            <span class="secondary_text">{{ dumpSum }} SOL</span>
            <span class="project_block_mini_header">Profit Estimate</span>
            <span class="secondary_text">{{ profitEstimate !== null ? profitEstimate.toFixed(9) : null }} SOL</span>
            <div class="buttons">
              <button class="button" @click="dumpClick">Dump</button>
              <button class="button" @click="semiDumpClick">Semi Dump</button>
            </div>
          </div>
        </div>

          <div class="project_block">
          <div class="project_block_header">
            <span>Holders Data</span>
          </div>
          <div class="projectInfo" style="grid-template-columns: 1fr">
            <div class="infoWallets" style="font-weight: bold">
              <p>SOL / Percentage</p>
              <p> {{ this.totalHoldersPercent }}%</p>
              <p></p>
            </div>
          </div>
          <div class="projectInfo">
            <div class="infoWallets" v-for="(item, index) in holders" :key="item">
              <p>
                {{ index + 1 }}.
                <a :href="'https://solscan.io/account/' + item.owner">{{ item.owner.slice(-5) }}</a>
              </p>
              <p>{{ item.uiAmount.toFixed(2) }} SOL ({{ item.supplyPercent.toFixed(2) }}%)</p>
            </div>
          </div>
        </div>

        <div class="project_block">
          <div class="project_block_header">
            <span>Send Comment</span>
          </div>
          <div class="project_block_finance">
            <span class="project_block_mini_header">Enter comment text</span>
            <textarea v-model="commentToSend" placeholder="Please enter comment text"></textarea>
            <div class="upload_photo_block">
              <div class="upload_photo" @click="selectFile">
                <span>Upload photo</span>
                <input @change="onFileChange" type="file" class="upload_input" />
              </div>
              <div class="button" v-if="commentFileToSend" @click="commentFileToSend = null">X</div>
            </div>
            <div class="button" @click="sendComment">Send</div>
          </div>
        </div>
        <div class="project_block">
          <div class="project_block_header">
            <span>Spread</span>
          </div>
          <div class="multi-select">
            <Multiselect v-model="selectedWalletSpread" select-label="" deselect-label="" limit="1" :options="wallets || []" label="wallet" track-by="id" :multiple="true" :close-on-select="false" placeholder="Please select wallet" @update:modelValue="(val) => console.log('modelValue updated:', val)">
              <template #option="{ option }">
                <div>{{ option.publicKey.slice(-5) }} - {{ option.balance >= 0 ? option.balance.toFixed(3) : null }} SOL</div>
              </template>
              <template #tag="{ option }">
                <span class="multiselect_tag">
                  {{ option.publicKey.slice(-5) || "Unnamed Wallet" }}
                </span>
              </template>
            </Multiselect>
            <div class="select_all" id="spread" @click="selectAllWallets($event, 'spread')">
              <img src="../assets/select_all.png" />
            </div>
          </div>
          <div class="input">
            <input type="text" v-model="solAmountSpread" />
            <span>SOL</span>
          </div>
          <button class="button" @click="spreadCash">Spread</button>
        </div>
      </div>
      
      <div class="project_under_blocks">
        <div class="project_block">
          <div class="project_block_header">
            <span>Token Data</span>
            <div class="jito_tip">
              <div class="axiom-token-watches">👁️ {{ axiomTokenWatches }}</div>
              <div class="select_token">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 6L11 6" stroke="#60CB89" stroke-width="2" stroke-linecap="round" />
                  <path d="M7 14L10 14" stroke="#60CB89" stroke-width="2" stroke-linecap="round" />
                  <path d="M7 10L13 10" stroke="#60CB89" stroke-width="2" stroke-linecap="round" />
                  <path d="M17 10V8C17 5.17157 17 3.75736 16.1213 2.87868C15.2426 2 13.8284 2 11 2H9C6.17157 2 4.75736 2 3.87868 2.87868C3 3.75736 3 5.17157 3 8V14C3 16.8284 3 18.2426 3.87868 19.1213C4.75736 20 6.17157 20 9 20H10" stroke="#60CB89" stroke-width="2" />
                  <circle cx="15.5" cy="16.5" r="2.5" stroke="#60CB89" stroke-width="2" />
                  <path d="M19 20L17.5 18.5" stroke="#60CB89" stroke-width="2" stroke-linecap="round" />
                </svg>
                <Transition name="fade">
                  <div class="custom-dropdown">
                    <div class="item" v-for="t of tokens" :key="t.id" @click="handleSelectPickToken(t)">
                      {{ t.name }}
                    </div>
                  </div>
                </Transition>
              </div>
              <a :href="`https://pump.fun/coin/${this.selectedToken.mintPublicKey}`" target="_blank" class="link_pumpfun">
                <img src="../assets/pump_fun.png" />
              </a>
              <a :href="`https://axiom.trade/meme/${this.tokenBondingCurve}`" target="_blank" style="filter: invert();" class="link_axiom">
                <img src="../assets/axiom.svg" />
              </a>
              <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="isShowNotifications = true" style="cursor: pointer">
                <path
                  d="M15.6727 20.2547H2.33863C1.87797 20.2604 1.42613 20.1282 1.04117 19.8752C0.656201 19.6222 0.355691 19.2599 0.178243 18.8348C0.000794999 18.4097 -0.0454844 17.9413 0.0453502 17.4897C0.136185 17.0381 0.359984 16.624 0.687997 16.3005C1.17875 15.8211 1.56885 15.2486 1.83541 14.6165C2.10198 13.9844 2.23964 13.3054 2.24034 12.6194V9.663C2.2668 7.88782 2.99065 6.19431 4.25554 4.94831C5.52043 3.70232 7.22479 3.00388 9.00044 3.00388C10.7761 3.00388 12.4804 3.70232 13.7453 4.94831C15.0102 6.19431 15.7341 7.88782 15.7605 9.663V12.6209C15.7613 13.3068 15.899 13.9856 16.1656 14.6176C16.4322 15.2496 16.8222 15.822 17.3129 16.3013C17.64 16.6242 17.8633 17.0372 17.9543 17.4877C18.0453 17.9381 17.9998 18.4055 17.8237 18.83C17.6476 19.2545 17.3489 19.6168 16.9657 19.8706C16.5825 20.1244 16.1324 20.2581 15.6727 20.2547ZM9.00569 4.50105C8.8067 4.50105 8.61586 4.42201 8.47515 4.28133C8.33445 4.14064 8.2554 3.94983 8.2554 3.75087V0.750175C8.2554 0.551216 8.33445 0.360406 8.47515 0.219721C8.61586 0.079036 8.8067 0 9.00569 0C9.20468 0 9.39552 0.079036 9.53622 0.219721C9.67693 0.360406 9.75598 0.551216 9.75598 0.750175V3.75087C9.75598 3.94983 9.67693 4.14064 9.53622 4.28133C9.39552 4.42201 9.20468 4.50105 9.00569 4.50105ZM12.1869 21.7551C11.9534 22.4119 11.5222 22.9803 10.9526 23.3822C10.383 23.7842 9.70288 24 9.00569 24C8.3085 24 7.62841 23.7842 7.05881 23.3822C6.4892 22.9803 6.05802 22.4119 5.82447 21.7551H12.1869Z"
                  fill="#60cb89"
                />
              </svg>
            </div>
          </div>
          <div class="project_block_finance">
            <div class="project_data" v-if="selectedToken">
              <div class="info-labels">
                <div>Name</div>
                <div class="info-labels-bold">{{ selectedToken.name }} ({{ selectedToken.symbol }})</div>
                <div>Description</div>
                <div class="info-labels-bold">
                  {{ selectedToken.description ? (selectedToken.description.length > 0 ? selectedToken.description : "Отсутствует") : "Отстутствует" }}
                </div>
                <div>Funding</div>
                <div class="info-labels-bold">{{ payerIdBalance ? payerIdBalance.toFixed(5) : "..." }} SOL</div>
                <div>Launch</div>
                <div class="info-labels-bold">
                  {{ new Date(selectedToken.deployedAt).toLocaleString().replace(",", "") }}
                </div>
                <div>Profit Estimate</div>
                <div class="info-labels-bold">{{ profitEstimate !== null ? profitEstimate.toFixed(9) : null }} SOL</div>
                <div>Cashback</div>
                <div class="info-labels-bold">{{ selectedToken.is_cashback ? '✅' : '❌' }}</div>
                <div>On Sell</div>
                <div class="info-labels-bold">{{ PNL1 ? PNL1.count : null }} SOL</div>
              </div>

              <!-- <div class="divider"></div> -->
            </div>
            <button class="button" @click="redeemAllSol">Redeem All SOL</button>
            <button class="button" @click="getBalances">Update BalancesL</button>
          </div>
        </div>


        <div class="project_block">
          <div class="project_block_header">
            <span>Recent Trades</span>
            <div class="trades_filter">
              <p style="white-space: nowrap">External</p>
              <label class="ios-switch">
                <input type="checkbox" v-model="tradesSelfOnly" />
                <span class="slider"></span>
              </label>
              <button class="button" style="font-size: 20px; padding: 4px 15px" @click="tradesFilter = tradesFilterNumber(Number(tradesFilter) - 0.001)">-</button>
              <input class="input" type="number" v-model="tradesFilter" />
              <button class="button" style="font-size: 20px; padding: 4px 15px" @click="tradesFilter = tradesFilterNumber(Number(tradesFilter) + 0.001)">+</button>
            </div>
          </div>
          <div class="projectInfo" style="grid-template-columns: 1fr">
            <div class="infoWallets" style="font-weight: bold; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 2fr">
              <p>Account</p>
              <p>Type</p>
              <p>SOL</p>
              <p>Token</p>
              <p>PnL</p>
              <p>Time</p>
            </div>
          </div>
          <div class="projectInfo" style="grid-template-columns: 1fr">
            <div class="infoWallets" v-for="item in transactions.filter((i) => i.sol_amount >= tradesFilter && (!tradesSelfOnly || !(wallets || []).some((w) => w.publicKey === i.wallet)))" :key="item" style="grid-template-columns: 1fr 1fr 1fr 1fr 1fr 2fr">
              <p :style="(wallets || []).some((wallet) => wallet.publicKey === item.wallet) ? null : 'color: #b159ff;'">
                {{ item.wallet.slice(-5) }}
              </p>
              <p :style="item.type == 'buy' ? 'color: #60cb89;' : 'color: #cb6060;'">
                {{ item.type.charAt(0).toUpperCase() + item.type.slice(1) }}
              </p>
              <p>{{ item.sol_amount != null ? Number(item.sol_amount).toFixed(2) : "..." }}</p>
              <p>{{ formatNumberTransaction(item.token_amount) }}</p>
              <p v-if="walletPnLMap[item.wallet]" :style="walletPnLMap[item.wallet].pnl >= 0 ? 'color: #60cb89;' : 'color: #cb6060;'">
                {{ walletPnLMap[item.wallet].pnl >= 0 ? "+" : "" }}{{ walletPnLMap[item.wallet].pnl.toFixed(3) }}
              </p>
              <p v-else>—</p>
              <p>
                {{ new Date(item.timestamp).toLocaleTimeString("ru-RU") }}
                {{ new Date(item.timestamp).toLocaleDateString("ru-RU").slice(0, -5) }}
              </p>
            </div>
          </div>
        </div>

        
        <div class="photon">
          <div class="project_block">
            <div class="project_block_header">
              <span>Photon Config</span>
            </div>
            <span class="project_block_mini_header">Photon Fee (in %)</span>
            <div class="input medium">
              <input v-model="photonFee" type="text" placeholder="Enter buy slippage" />
            </div>
            <span class="project_block_mini_header">Photon Traders (in %)</span>
            <div class="input medium">
              <input v-model="photonTradersPercent" type="text" placeholder="Enter buy slippage" />
            </div>
            <span class="project_block_mini_header">Axiom Traders (in %)</span>
            <div class="input medium">
              <input v-model="axiomTradersPercent" type="text" placeholder="Enter buy slippage" />
            </div>
            <span class="project_block_mini_header">BullX Traders (in %)</span>
            <div class="input medium">
              <input v-model="bullxTradersPercent" type="text" placeholder="Enter buy slippage" />
            </div>
            <span class="project_block_mini_header">Padre Traders (in %)</span>
            <div class="input medium">
              <input v-model="padreTradersPercent" type="text" placeholder="Enter buy slippage" />
            </div>
            <span class="project_block_mini_header">GMGN Traders (in %)</span>
            <div class="input medium">
              <input v-model="gmgnTradersPercent" type="text" placeholder="Enter buy slippage" />
            </div>
            <button class="button" @click="updatePhotonConfig">Update</button>
          </div>
        </div>
      </div>
      

    </div>
    
  </div>

  

  <Transition name="fade">
    <div class="notifications_wrapper" v-if="isShowNotifications" @click="closeShowNotifications">
      <div class="notifications_block">
        <span class="notifications_header">Уведомления</span>
        <div class="notifications_list" v-if="notifications.length > 0">
          <div class="notify" v-for="n of notifications" :key="n">
            <span class="notify_status">
              <img v-if="n.type == 'success'" src="../assets/success_notify.svg" />
              <img v-else src="../assets/error_notify.svg" />
            </span>
            <span class="notify_text">{{ n.message }} </span>
            <span class="notify_time">{{ n.time }} </span>
          </div>
        </div>
        <span v-else>Отсутствуют</span>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div class="notifications_wrapper" v-if="isShowHeatLogs" @click="closeShowHeatLogs">
      <div class="notifications_block" style="width: fit-content; max-width: 50rem">
        <div class="notifications_header">Логи прогрева</div>
        <div class="heatlogs_list" v-if="heatLogs.length > 0">
          <table class="heatlogs_table">
            <thead>
              <tr>
                <th>Время</th>
                <th>Кошелёк</th>
                <th>Действие</th>
                <th>Данные</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, index) in heatLogs" :key="index">
                <td>{{ new Date(log.timestamp).toLocaleTimeString() }}</td>
                <td>{{ log.wallet.slice(-5) }}</td>
                <td>{{ log.action }}</td>
                <td>
                  <!-- Use formatted heat log data -->
                  <span v-if="formatHeatLogData(log).type === 'text'">{{ formatHeatLogData(log).content }}</span>
                  <!-- Отображаем buy_instructions -->
                  <template v-else-if="formatHeatLogData(log).type === 'buy_instructions'">
                    Количество токенов: {{ formatHeatLogData(log).tokenAmount }}<br />
                    Монета: <a :href="`pump.fun/coin/${formatHeatLogData(log).tokenMint}`" target="_blank">Перейти</a>
                  </template>
                  <template v-else-if="formatHeatLogData(log).type === 'send_sol'"> Отправлено SOL: {{ formatHeatLogData(log).solAmount }} </template>
                  <!-- Для других типов данных, если понадобится -->
                  <span v-else>Неизвестный тип данных</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span v-else>Логов нет</span>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div class="notifications_wrapper" v-if="isShowArchiveBlock" @click="closeArchiveBlock">
      <div class="notifications_block">
        <div class="notifications_header">Архив кошельков</div>
        <div class="notifications_header" style="font-size: 14px; color: gray; font-family: 'Proxima Nova'">Нажмите на кошелёк, чтобы вынести из архива</div>
        <div class="archive_wallets_block" v-if="archivedWallets.length > 0">
          <div class="project_block_wallet" v-for="i of archivedWallets" :key="i" :class="[isSelected(i) ? 'selected' : '', getOwnershipClass(i)]" :id="i.id" @click="removeFromArchive(i)">
            <span>{{ i.publicKey.slice(-5) }}</span>
            <span>{{ ((i.balanceSpl / 1e9) * 100).toFixed(4) }}%</span>
            <span>{{ Math.round(Number(i.balance) * 1000) / 1000 }} SOL</span>
          </div>
        </div>
        <span v-else>Отсутствуют</span>
      </div>
    </div>
  </Transition>
</template>

<script>
import axios from "axios";
//import { connection } from "@/services/walletMonitor";

import { connection, RPC_ENDPOINT } from "@/services/solanaClient";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import Slider from "@vueform/slider";
import Multiselect from "vue-multiselect";
import { startMonitoring } from "@/services/walletMonitor";
import { EventBus } from "@/services/eventBus";
import { fetchPastTransactions } from "@/services/walletMonitor";
import { PublicKey } from "@solana/web3.js";
import { TOKEN_2022_PROGRAM_ID, AccountLayout } from "@solana/spl-token";
import { io } from "socket.io-client";
//import WebSocket from 'ws';

const WITH_RETURN_STORAGE_KEY = "project_component_with_return";

const getInitialWithReturn = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return true;
  }

  try {
    const storedValue = window.localStorage.getItem(WITH_RETURN_STORAGE_KEY);

    if (storedValue === null) {
      return true;
    }

    return storedValue === "true";
  } catch (error) {
    return true;
  }
};

const persistWithReturn = (value) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  try {
    window.localStorage.setItem(WITH_RETURN_STORAGE_KEY, value ? "true" : "false");
  } catch (error) {
    // Ignore storage write errors (private mode, quota, etc.)
  }
};

export default {
  name: "ProjectComponent",
  data() {
    return {
      optionsPickAccount: [
        {
          label: "Loading...",
          key: "Loading...",
        },
      ],
      optionsPickToken: [
        {
          label: "ffasf",
          key: 123,
        },
      ],
      isProject: true,
      isCreateWallet: false,
      isInfoWallet: false,
      tokens: [],
      selectedToken: {},
      wallets: [],
      preHeatedWalletCount: 0,
      // wallets: Array.from({ length: 49 }, (_, i) => ({
      //   id: i + 1,
      //   wallet: `CO8lS${i > 9 ? Math.floor(i / 10) : i}`,
      //   percents: "3.5%",
      //   balance: "0.02",
      //   activated: false,
      // })),
      virtualBalances: {}, // { walletId: { balance: 0, pendingOperations: [] } }
      activeOperations: new Set(), // Храним ID кошельков с активными операциями

      selectedWallets: [],
      selectedWalletBuy: [],
      selectedWalletSell: {
        publicKey: ".........",
      },
      selectedWalletSpread: [],
      walCountCreate: 1,
      solAmountCreate: "",
      tokenBondingCurve: "",


      solAmountBuyTemplates: this.$store.getters.getSolAmountBuyTemplates,
      solAmountBuyTemplatesNew: null,
      solAmountBuy: null,
      solAmountBuyRandom: null,
      solAmountSpread: null,
      solAmountBump: null,
      withReturn: getInitialWithReturn(),
      photonFee: 0,
      photonTradersPercent: 0,
      axiomTradersPercent: 0,
      bullxTradersPercent: 0,
      padreTradersPercent: 0,
      gmgnTradersPercent: 0,
      slippageBuy: 20,
      sellPercentSell: 10,
      jitoTip: 0.00005,
      walletsSol: null,
      totalSPLBalance: 0,
      creatorFee: 0,
      totalSOLBalance: 0,
      isSpreadCash: false,
      PNL1: {
        count: 0,
        totalSPLBalance: 0,
        solanaSum: 0,
      },
      columns: [
        { title: "ID", key: "id" },
        { title: "Public Key", key: "publicKey" },
        { title: "Private Key", key: "privateKey" },
        { title: "Balance, SOL", key: "balance" },
        { title: `Balance, TOKEN`, key: "balanceSpl" },
      ],
      infoWallets: [],
      holders: [],
      totalHoldersPercent: 0,
      dumpSum: "0",
      payerIdBalance: "",
      profitEstimate: null,
      isHeatModal: false,
      isSendComment: false,
      axiomTokenWatches: "0",
      isBumpBot: false,
      bumpBurst: false,
      bumpAmount: "",
      bumpMode: "",
      bumpInfo: null,
      bumpInitInfo: null,
      bumpWallet: "",
      bumpSolAmount: "",
      bumpBalance: 0,
      
      commentToSend: "",
      commentFileToSend: null,
      selectedWalletHeat: [],
      isHeatSpin: false,
      selectedWalletComment: null,

      isRandomSelect: false,
      interval: null,
      holdersIntervalId: null,
      lastTransactionsIntervalId: null,
      migrationIntervalId: null,
      activeOperationsIntervalId: null,
      documentClickHandler: null,
      stopWalletMonitoring: null,
      eventHandlers: {
        onSolBalanceUpdated: null,
        onTokenBalanceUpdated: null,
        onTransaction: null,
      },
      coreMetricsRefreshTimeoutId: null,
      holdersRefreshTimeoutId: null,
      lastHoldersRefreshAt: 0,
      isPnlLoading: false,
      pendingPnlRefresh: false,
      isHoldersLoading: false,
      pendingHoldersRefresh: false,
      transactions: [],
      isEditTemplate: false,
      tradesFilter: 0.1,
      tradesSelfOnly: false,
      highlightUnused: false,

      isShowNotifications: false,
      notifications: [],

      minHeatAmount: "",
      maxHeatAmount: "",
      heatLogs: [],
      isShowHeatLogs: false,

      socket: null,

      showContextMenuWallet: false,
      isShowArchiveBlock: false,
      contextPickedWallet: null,
      menuPosition: { x: 0, y: 0 },
      archivedWallets: [],

      padreEyesCount: 200,
      padreEyesStatus: false,
      padreActiveAccounts: 0
    };
  },
  components: {
    Slider,
    Multiselect,
  },
  methods: {
    handleRightClickWallet(event) {
      console.log(event.target.closest("div"));
      this.contextPickedWallet = this.wallets.filter((wallet) => wallet.id === event.target.closest("div").id)[0];
      console.log(this.contextPickedWallet);
      this.menuPosition = { x: event.layerX, y: event.layerY };
      this.showContextMenuWallet = true;
      console.log(this.showContextMenuWallet);
    },
    closeContextMenu() {
      this.showContextMenuWallet = false;
    },
    archiveWallet() {
      const id = this.contextPickedWallet.id;
      this.archivedWallets.push(this.contextPickedWallet);
      this.wallets = this.wallets.filter((wallet) => wallet.id !== id);
      this.$store.commit("setArchiveWallets", {
        token: this.selectedToken.id,
        wallet: this.contextPickedWallet,
      });
      console.log(this.$store);
      this.closeContextMenu();
    },
    removeFromArchive(wallet) {
      this.archivedWallets = this.archivedWallets.filter((w) => w.id !== wallet.id);
      this.wallets.push(wallet);
      this.$store.commit("removeArchiveWallets", {
        token: this.selectedToken.id,
        wallet: wallet,
      });
    },
    safeNum(val) {
      const n = typeof val === "string" ? Number(val.replace(",", ".")) : Number(val);
      return Number.isFinite(n) ? n : 0;
    },
    formatHeatLogData(logEntry) {
      const { action, data } = logEntry;
      switch (action) {
        case "set_username":
        case "set_followers":
          return {
            type: "text",
            content: data ? "Установлено" : "Не установлено",
          };
        case "generate_buy_instructions":
          if (typeof data === "object" && data !== null) {
            const formattedAmount = data.tokenAmount != null ? parseFloat(data.tokenAmount).toFixed(6) : "N/A";
            const tokenMint = data.tokenMint || "N/A";
            return {
              type: "buy_instructions",
              tokenAmount: formattedAmount,
              tokenMint: tokenMint,
            };
          }
          return {
            type: "text",
            content: JSON.stringify(data),
          };
        case "send_sol":
          if (typeof data === "object" && data !== null) {
            const formattedAmount = data.solAmount != null ? parseFloat(data.solAmount).toFixed(6) : "N/A";
            return {
              type: "send_sol",
              solAmount: formattedAmount,
            };
          }
          return {
            type: "text",
            content: JSON.stringify(data),
          };
        default:
          return {
            type: "text",
            content: JSON.stringify(data),
          };
      }
    },
    initSocket() {
      const userToken = this.$store.getters.getUserData.key;
      if (this.socket) {
        this.socket.close();
      }
      console.log("Попытка подключения к сокету с токеном:", userToken);
      this.socket = io(`${process.env.VUE_APP_WSHOST}`, {
        auth: {
          token: userToken,
        },
        transports: ["websocket"],
      });
      this.socket.on("connect", () => {
        console.log("Соединение с WebSocket установлено. ID сокета:", this.socket.id);
        
        this.socket.on("AXIOM_EVENT", (data) => {
          try {
            const axiom_data_json = JSON.parse(data)
            //console.log(this.tokenBondingCurve.toString(), axiom_data_json.room.split('-')[1])
            //console.log("AXIOM_EVENT")
           // if(this.tokenBondingCurve.toString() == axiom_data_json.room.split('-')[1]) {
              this.axiomTokenWatches = axiom_data_json.content
           // }
          } catch (error) {
            console.log(error)
          }
        })
      });
      this.socket.on("disconnect", (reason) => {
        console.log("Соединение с WebSocket закрыто. Причина:", reason);
      });

      this.socket.on("connect_error", (error) => {
        console.error("Ошибка подключения к WebSocket:", error);
        console.log({ type: "error", message: `Ошибка подключения к WebSocket: ${error.message}` });
      });

      // Пример обработчика получения данных от сокета
      this.socket.on("HEATLOG", (data) => {
        console.log("Получены новые данные от сокета:", data);
        const logEntry = {
          ...data,
          timestamp: Date.now(), // или сервер может присылать timestamp
        };
        this.heatLogs.unshift(logEntry); // Добавляем в массив
        if (this.heatLogs.length > 50) {
          // например, хранить последние 100
          this.heatLogs.pop(); // удаляем последний элемент (самый старый)
        }
        // Здесь обрабатывайте полученные данные, например, обновляйте состояние компонента
      });

      // Пример обработчика ошибок от сервера
      this.socket.on("server_error", (errorMessage) => {
        console.error("Ошибка от сервера через WebSocket:", errorMessage);
        console.log({ type: "error", message: `Ошибка от сервера: ${errorMessage}` });
      });
    },
    async returnFee() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/collect_creator_fee`,
          {
            tokenId: this.selectedToken.id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        console.log(res);
      } catch (err) {
        console.log(err);
        this.showNotify({ type: "error", message: err.response.data.message });
      }
    },
    // getLastTransactions removed — trades now come from blockchain directly
    getOwnershipClass(i) {
      const percent = (i.balanceSpl / 1e9) * 100;
      if (percent < 1) return "wallet-green";
      if (percent >= 1 && percent <= 1.5) return "wallet-yellow";
      if (percent > 1.5) return "wallet-red";
    },
    closeShowNotifications(e) {
      if (e.target.classList.contains("notifications_wrapper")) {
        this.isShowNotifications = false;
      }
    },
    closeShowHeatLogs(e) {
      if (e.target.classList.contains("notifications_wrapper")) {
        this.isShowHeatLogs = false;
      }
    },
    closeArchiveBlock(e) {
      if (e.target.classList.contains("notifications_wrapper")) {
        this.isShowArchiveBlock = false;
      }
    },
    showNotify(info) {
      if (info.type === "success") {
        this.toast.success();
      } else if (info.type === "error") {
        this.toast.error();
      }
      this.notifications.unshift({
        type: info.type,
        message: info.message,
        time: new Date().toLocaleTimeString(),
      });
    },
    async depositBumpWallet() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/bump/send-sol/${this.bumpInitInfo.tokenId}`,
          {
            solAmount: this.solAmountBump,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        console.log("пополняем бамп кошель", res);
        setTimeout(() => {
          this.checkBumpBalance();
        }, 3000);
        this.showNotify({ type: "success", message: "Пополнение кошелька успешно!" });
      } catch (err) {
        console.log(err);
        this.showNotify({ type: "error", message: "Произошла ошибка при пополнении кошелька" });
      }
    },
    async getPadreEyesInfo () {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/status`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )

        const data = res.data

        this.padreEyesCount = data.base
        this.padreEyesStatus = data.running
        this.padreActiveAccounts = data.idle + data.active

      } catch (error) {
        console.log(error)
      }
    },
    async startPadreEyes () {
      try {
        const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/start`,
        {
        
                "pairData": { 
                  "pairAddress": `solana-${this.tokenBondingCurve.toString()}`,
                  "tokenAddress":`solana-${this.tokenBondingCurve.toString()}`
              },
              "base": this.padreEyesCount
          
        },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })

          const data = res.data

          this.padreEyesCount = data.base
          this.padreEyesStatus = data.running
          this.padreActiveAccounts = data.idle + data.active

          console.log(res.data)
      } catch (error) {
        console.log(error)
      }
    },
    async stopPadreEyes () {
      try {
        const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/stop`,
        {
        },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })

          const data = res.data
          
          this.padreEyesCount = data.base
          this.padreEyesStatus = data.running
          this.padreActiveAccounts = data.idle + data.active
      } catch (error) {
        console.log(error)
      }
    },
    async updatePadreEyesBase () {
      const res = await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/base`,
        {
              "base": Number(this.padreEyesCount)
        },
      {
        headers: {
          Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
        },
      })

      const data = res.data

      this.padreEyesCount = data.base
      this.padreEyesStatus = data.running
      this.padreActiveAccounts = data.idle + data.active
    },
    async returnBumpCash() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/bump/return-sol/${this.bumpInitInfo.tokenId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        console.log("выводим кэш", res);
        setTimeout(() => {
          this.checkBumpBalance();
        }, 3000);
        this.showNotify({ type: "success", message: "Деньги с бампа успешно выведены!" });
      } catch (err) {
        console.log(err);
        this.showNotify({ type: "error", message: "Произошла ошибка при выводе с бампа" });
      }
    },
    async getPreHeatedWalletsCount () {
      try {
        const res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/wallet/pre-heated-count`, {
            headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          }
        })

        return res.data
      } catch (error) { console.log(error) }
    },  
    returnHeat() {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/return-heat`,
          {
            walletIds: this.selectedWalletHeat.map((l) => l.id),
            tokenId: this.selectedToken.id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.showNotify({ type: "success", message: "Деньги с прогрева бэкнуты" });
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: "Произошла ошибка при возврате средств с прогрева" });
        });
    },
    tradesFilterNumber(value) {
      console.log(value);
      return value.toFixed(3); // 3 знака после запятой
    },
    formatNumberTransaction(value) {
      if (value < 1000) return value;

      const abbreviations = [
        { threshold: 1e6, suffix: "кк" }, // миллион -> кк
        { threshold: 1e3, suffix: "к" }, // тысяча
      ];

      for (let i = 0; i < abbreviations.length; i++) {
        const { threshold, suffix } = abbreviations[i];
        if (value >= threshold) {
          const shortened = (value / threshold).toFixed(1).replace(/\.0$/, "");
          return shortened + suffix;
        }
      }

      return value.toString();
    },
    editTemplate() {
      if (!this.isEditTemplate) {
        this.solAmountBuyTemplatesNew = this.solAmountBuyTemplates;
        this.isEditTemplate = true;
      } else {
        this.isEditTemplate = false;
        this.solAmountBuyTemplates = this.solAmountBuyTemplatesNew;
        this.$store.commit("setSolAmountBuyTemplates", this.solAmountBuyTemplates);
      }
    },
    isSelected(wallet) {
      return this.selectedWallets.includes(wallet.id);
      // или wallet.id — зависит от того, что ты хранишь
    },
    handleSelectPickToken(key) {
      this.selectedToken = key;
      this.$store.commit("setSelectedToken", this.selectedToken);
      console.log("ААААААААААААА", this.$store.getters.getSelectedToken);
      window.location.reload();
      // this.getWallets(this.selectedToken.id)
      // this.initBumpBot()
    },
    handlePickWallet(wallet) {
      // let elem = event.target.closest("div")
      this.isRandomSelect = false;
      const walletId = wallet.id;
      this.selectedWallets = [];
      if (this.selectedWallets[0] == walletId) {
        this.selectedWallets = [];
      } else {
        this.selectedWallets.push(walletId);
      }
      // console.log(this.selectedWallets)
    },
    initVirtualBalances() {
      this.wallets.forEach((wallet) => {
        // В Vue 3 просто присваиваем
        this.virtualBalances[wallet.id] = {
          balance: wallet.balance,
          pendingOperations: [],
        };
      });
    },
    updatePhotonConfig () {
      this.patchToken({
        pro_traders_percent: Number(this.photonTradersPercent),
        photon_percent: Number(this.photonFee),
        pro_traders_percent_bullx: Number(this.bullxTradersPercent),
        pro_traders_percent_axiom: Number(this.axiomTradersPercent),
        pro_traders_percent_padre: Number(this.padreTradersPercent),
        pro_traders_percent_gmgn: Number(this.gmgnTradersPercent),
      })
    },
    // Получение актуального виртуального баланса
    getVirtualBalance(walletId) {
      const wallet = this.wallets.find((w) => w.id === walletId);
      const virtual = this.virtualBalances[walletId];

      if (!virtual) {
        return wallet ? wallet.balance : 0;
      }

      // Считаем сколько заблокировано в pending операциях
      const pendingAmount = virtual.pendingOperations.reduce((sum, op) => {
        return sum + (op.type === "buy" ? op.amount : 0);
      }, 0);

      return wallet.balance - pendingAmount;
    },
    handlePickWalletRandom(filter) {
      this.selectedWallets = [];
      this.isRandomSelect = true;
      const elems = document.querySelectorAll(".project_block_wallet");

      for (let i = 1; i < elems.length; i++) {
        elems[i].classList.contains("selected") ? elems[i].classList.remove("selected") : null;
      }

      const allWallets = this.createWalletsSnapshot();

      let filteredWallets = allWallets.filter((wallet) => {
        // Exclude wallets with active operations
        if (this.activeOperations.has(wallet.id)) {
          return false;
        }

        // Проверяем есть ли pending операции в virtualBalances
        if (this.virtualBalances[wallet.id]?.pendingOperations?.length > 0) {
          return false;
        }

        if (filter === "sell") {
          return wallet.balanceSpl > 0;
        }

        // Запрещаем покупку с zeroblock-кошельков
        if (filter === "buy" && wallet.zeroblock) {
          return false;
        }

        return true;
      });

      if (filteredWallets.length === 0) {
        console.log("Нет доступных кошельков для выбора.");
        this.showNotify({ type: "error", message: "Все кошельки заняты, подождите..." });
        return;
      }

      const firstWalletId = allWallets[0]?.id;
      filteredWallets = filteredWallets.filter((wallet) => wallet.id !== firstWalletId);

      if (filter === "buy") {
        let priorityWallets = [];
        let priority = -1;

        if (this.solAmountBuyRandom > this.payerIdBalance) {
          priorityWallets = filteredWallets.filter((w) => {
            const virtualBalance = this.getVirtualBalance(w.id);
            return virtualBalance >= this.solAmountBuyRandom;
          });
        } else {
          // Use virtual balance for all checks
          priorityWallets = filteredWallets.filter((w) => {
            const virtualBalance = this.getVirtualBalance(w.id);
            return w.balanceSpl === 0 && virtualBalance < 0.05;
          });
          priority = 2;

          if (priorityWallets.length === 0) {
            priorityWallets = filteredWallets.filter((w) => {
              const virtualBalance = this.getVirtualBalance(w.id);
              return w.balanceSpl > 0 && (w.balanceSpl / 1e9) * 100 < 1.5 && virtualBalance >= 0.01;
            });
            priority = 1;
          }

          if (priorityWallets.length === 0) {
            priorityWallets = filteredWallets.filter((w) => {
              const virtualBalance = this.getVirtualBalance(w.id);
              return w.balanceSpl === 0 && virtualBalance >= 0.01;
            });
            priority = 0;
          }

          if (priorityWallets.length === 0) {
            priorityWallets = filteredWallets.filter((w) => {
              return (w.balanceSpl / 1e9) * 100 > 1.5;
            });
            priority = -1;
          }
        }
        console.log(`Приоритет выбран: ${priority}`, priorityWallets);
        if (priorityWallets.length === 0) {
          console.log("Нет кошельков для выбранного приоритета.");
          this.showNotify({ type: "error", message: "Все подходящие кошельки заняты" });
          return;
        }

        const walletWithMinBalance = priorityWallets.reduce((minWallet, currentWallet) => {
          return currentWallet.balanceSpl < minWallet.balanceSpl ? currentWallet : minWallet;
        });

        const selectedWallet = walletWithMinBalance;

        // ВАЖНО: Сразу помечаем кошелек как занятый
        this.activeOperations.add(selectedWallet.id);

        this.selectedWallets.push(selectedWallet.id);
        document.getElementById(`${selectedWallet.id}`).classList.add("selected");
      } else {
        // --- Новая логика для продажи ---
        console.log("Фильтр продажи активен");

        // 1. Приоритет: Красные кошельки (percent > 1.5)
        let priorityWallets = filteredWallets.filter((w) => (w.balanceSpl / 1e9) * 100 > 1.5 && !w.pendingSell);
        console.log("Красные кошельки для продажи:", priorityWallets);

        // 2. Если красных нет, ищем желтые (1% <= percent <= 1.5%)
        if (priorityWallets.length === 0) {
          priorityWallets = filteredWallets.filter((w) => (w.balanceSpl / 1e9) * 100 >= 1 && (w.balanceSpl / 1e9) * 100 <= 1.5 && !w.pendingSell);
          console.log("Желтые кошельки для продажи:", priorityWallets);
        }

        // 3. Если ни красных, ни желтых нет, берем все оставшиеся (зеленые и т.д.)

        if (priorityWallets.length === 0) {
          console.log("Нет доступных кошельков для продажи по цвету, беру зелёные.");
          priorityWallets = filteredWallets.filter((w) => (w.balanceSpl / 1e9) * 100 < 1 && !w.pendingSell);
        }

        // const randomIndex = Math.floor(Math.random() * priorityWallets.length);
        // const randomWallet = priorityWallets[randomIndex];
        // this.selectedWallets.push(randomWallet.id);
        // console.log("Выбран кошелек для продажи:", randomWallet);
        // document.getElementById(`${randomWallet.id}`).classList.add("selected");
        console.log(priorityWallets, "FILTER", filteredWallets);
        if (priorityWallets.length === 0) {
          console.warn("Нет приоритетных кошельков для выбора");
          return; // или другая логика обработки
        }
        const walletWithMaxBalance = priorityWallets.reduce((maxWallet, currentWallet) => {
          return currentWallet.balanceSpl > maxWallet.balanceSpl ? currentWallet : maxWallet;
        });

        const selectedWallet = walletWithMaxBalance;
        this.selectedWallets.push(selectedWallet.id);
        document.getElementById(`${selectedWallet.id}`).classList.add("selected");

        // const firstWalletId = allWallets[0]?.id;
        // filteredWallets = filteredWallets.filter((wallet) => wallet.id !== firstWalletId);
        // const randomIndex = Math.floor(Math.random() * filteredWallets.length);
        // const randomWallet = filteredWallets[randomIndex];
        // this.selectedWallets.push(randomWallet.id);
        // console.log("SELL", this.selectedWallets);
        // document.getElementById(`${randomWallet.id}`).classList.add("selected");
      }
    },
    createWalletsSnapshot() {
      return this.wallets.map((w) => ({
        id: w.id,
        balance: w.balance,
        balanceSpl: w.balanceSpl,
        pending: w.pending,
        pendingSell: w.pendingSell,
        publicKey: w.publicKey,
        zeroblock: w.zeroblock
      }));
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.commentFileToSend = file;
      console.log("Выбран файл", file);
    },
    selectAllWallets(e, method) {
      let target = e.target.closest("div");
      console.log(target.id);
      if (method == "heat") this.selectedWalletHeat.length > 0 ? (this.selectedWalletHeat = []) : (this.selectedWalletHeat = this.wallets);
      else if (method == "spread") this.selectedWalletSpread.length > 0 ? (this.selectedWalletSpread = []) : (this.selectedWalletSpread = this.wallets);
    },
    selectFile() {
      document.querySelector(".upload_input").click();
    },
    loadDataInfo() {
      this.infoWallets = this.wallets.map((wallet, id) => ({
        id: id + 1,
        publicKey: wallet.publicKey,
        privateKey: wallet.privateKey,
        balance: wallet.balance,
        balanceSpl: wallet.balanceSpl,
      }));
    },
    recalculateTotals() {
      this.totalSOLBalance = this.wallets.reduce((acc, item) => acc + this.safeNum(item.balance), 0);
      this.totalSPLBalance = this.wallets.reduce((acc, item) => acc + this.safeNum(item.balanceSpl), 0);
    },
    queueCoreMetricsRefresh() {
      if (this.coreMetricsRefreshTimeoutId) {
        clearTimeout(this.coreMetricsRefreshTimeoutId);
      }
      this.coreMetricsRefreshTimeoutId = setTimeout(() => {
        this.coreMetricsRefreshTimeoutId = null;
        this.getPayerBalance();
        this.loadPNL();
      }, 250);
    },
    queueHoldersRefresh() {
      const MIN_HOLDERS_REFRESH_MS = 1500;
      const elapsed = Date.now() - this.lastHoldersRefreshAt;

      if (elapsed >= MIN_HOLDERS_REFRESH_MS) {
        this.lastHoldersRefreshAt = Date.now();
        this.getHolders();
        return;
      }

      if (this.holdersRefreshTimeoutId) {
        return;
      }

      this.holdersRefreshTimeoutId = setTimeout(() => {
        this.holdersRefreshTimeoutId = null;
        this.lastHoldersRefreshAt = Date.now();
        this.getHolders();
      }, MIN_HOLDERS_REFRESH_MS - elapsed);
    },
    getProfitEstimate() {
      const onSell = this.safeNum(this.PNL1?.count);
      const walletsSol = this.safeNum(this.totalSOLBalance);
      const payerSol = this.safeNum(this.payerIdBalance);
      const deploySol = this.safeNum(this.selectedToken?.payerSolBalanceOnDeploy);
      const creatorFee = this.safeNum(this.creatorFee);

      this.profitEstimate = creatorFee + onSell + walletsSol + payerSol - deploySol;
    },
    spreadCash() {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/send`,
          {
            walletIds: this.selectedWalletSpread.map((l) => l.id),
            tokenId: this.selectedToken.id,
            solAmount: this.solAmountSpread,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.showNotify({ type: "success", message: "Деньги раскинуты" });
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
    },
    async subscribeToAxiomToken () {
      await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/token/axiom-subscribe`, { bondingCurve: this.tokenBondingCurve }, 
        {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        }
      )
    },
    async spreadCashToOneWallet(wallets, amount) {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/send-sol-and-buy`,
          {
            walletId: wallets[0],
            tokenId: this.selectedToken.id,
            sendSolAmount: amount.toFixed(3),
            buySolAmount: Number(this.solAmountBuyRandom),
            slippage: this.slippageBuy,
            withReturn: this.withReturn
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          this.showNotify({ type: "success", message: "Докидываю денег на кошелёк" });
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
      // .finally(() => {
      //   // Снимаем pending с выбранных кошельков
      //   const selectedWalletsInfo = this.wallets.filter((w) => wallets.includes(w.id));
      //   selectedWalletsInfo.forEach((wallet) => (wallet.pending = false));
      // });
    },
    createWallet() {
      // console.log("СОЗДАЮ")
      if (this.wallets.length > 75) {
        this.showNotify({ type: "error", message: "You can't create more than 75 wallets" });
      } else {
        axios
          .post(
            `${process.env.VUE_APP_SERVERHOST}/api/wallet/create-wallet`,
            {
              tokenId: this.selectedToken.id,
              count: this.walCountCreate,
              solAmount: this.solAmountCreate,
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            }
          )
          .then((res) => {
            console.log(res);
            this.showNotify({ type: "success", message: "Wallet successfully created" });
            console.log(this.selectedToken.id);
            this.getWallets(this.selectedToken.id);
          })
          .catch((err) => {
            console.log(err);
            this.showNotify({ type: "error", message: err.response.data.message });
          });
      }
    },
    heatWallets() {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/heat`,
          {
            walletIds: this.selectedWalletHeat.map((l) => l.id),
            tokenId: this.selectedToken.id,
            minSolAmount: this.minHeatAmount,
            maxSolAmount: this.maxHeatAmount,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          // this.isHeatSpin = true

          this.showNotify({ type: "success", message: "Waiting for heating your wallets (max 1 minute)" });
          // setTimeout(() => {
          //   this.isHeatSpin = false
          // }, 8000)
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
          // this.isHeatSpin = false
          // this.getBalances()
        });
    },
    sendComment() {
      console.log("test");
      let formDataFile = new FormData();
      formDataFile.append("tokenId", this.selectedToken.id);
      if (this.selectAllWallets[0]) return this.showNotify({ type: "error", message: "Выберите 1 кошелёк" });
      formDataFile.append("walletId", this.selectedWallets[0]);
      formDataFile.append("message", this.commentToSend);
      this.commentFileToSend ? formDataFile.append("file", this.commentFileToSend) : null;
      console.log([...formDataFile.entries()]);
      axios
        .post(`${process.env.VUE_APP_SERVERHOST}/api/token/comment`, formDataFile, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        .then((res) => {
          console.log("COMMENT", res);
          if (res.data == true) this.showNotify({ type: "success", message: "Comment successfully sended" });
          else this.showNotify({ type: "error", message: "Something went wrong" });
          this.clearFile();
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    generateRandomSum(num) {
      const chance = Math.random() * 100;
      const MIN_SOL = 0.0001;
      let result;

      if (chance <= 70) {
        // Плавное изменение ±10%
        const changePercent = this.getRandomArbitrary(-10, 10);
        result = num * (1 + changePercent / 100);
      } else {
        // Sharp random change +/-15%
        const strongChange = Math.random() < 0.5 ? 16 : -15;
        result = num * (1 + strongChange / 100);
      }
      // console.log(Math.max(result, MIN_SOL).toFixed(3))
      this.solAmountBuyRandom = Math.max(result, MIN_SOL).toFixed(3);
      this.buyToAccount();
    },
    async buyToAccount() {
      this.isRandomSelect ? this.handlePickWalletRandom("buy") : null;

      if (!this.selectedWallets[0]) {
        this.showNotify({ type: "error", message: "Нет доступных кошельков" });
        return;
      }

      const walletId = this.selectedWallets[0];
      const operationId = Date.now() + Math.random();
      const amount = Number(this.solAmountBuyRandom);

      // Добавляем операцию в pending
      this.addPendingOperation(walletId, {
        id: operationId,
        type: "buy",
        amount: amount,
        timestamp: Date.now(),
      });

      let randomSelectedWalletInfo = this.wallets.find((w) => w.id == walletId);
      const virtualBalance = this.getVirtualBalance(walletId);

      const wallet = this.wallets.find((w) => w.id === walletId);
      const walletBalance = await connection.getBalance(new PublicKey(wallet.publicKey))
      console.log(walletBalance, walletBalance * 1e-9, virtualBalance)
      try {
        if (randomSelectedWalletInfo && (walletBalance * 1e-9) < amount) {
          await this.spreadCashToOneWallet([walletId], amount + (amount * 0.30));
        } else {
          await this.buyToAccountFunctionWithTracking([walletId], operationId);
        }
      } catch (err) {
        // При ошибке удаляем из активных
        this.activeOperations.delete(walletId);
        this.removePendingOperation(walletId, operationId);
      }
    },
    // Добавление pending операции
    addPendingOperation(walletId, operation) {
      if (!this.virtualBalances[walletId]) {
        // В Vue 3 просто присваиваем новое свойство
        this.virtualBalances[walletId] = {
          balance: 0,
          pendingOperations: [],
        };
      }
      this.virtualBalances[walletId].pendingOperations.push(operation);
    },

    // Удаление pending операции
    removePendingOperation(walletId, operationId) {
      if (this.virtualBalances[walletId]) {
        this.virtualBalances[walletId].pendingOperations = this.virtualBalances[walletId].pendingOperations.filter((op) => op.id !== operationId);
      }
    },

    // Модифицированная функция покупки с отслеживанием
    async buyToAccountFunctionWithTracking(wallets, operationId) {
      const walletId = wallets[0];

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/buy`,
          {
            walletIds: wallets,
            tokenId: this.selectedToken.id,
            solAmount: this.solAmountBuyRandom,
            slippage: this.slippageBuy,
            jitoTip: this.jitoTip,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );

        if (res.data.ok) {
          this.showNotify({ type: "success", message: res.data.message });

          // Удаляем из активных через небольшую задержку
          setTimeout(() => {
            this.activeOperations.delete(walletId);
            this.removePendingOperation(walletId, operationId);
          }, 2000); // 2 секунды на обновление через сокет
        } else {
          // Сразу удаляем если ошибка
          this.activeOperations.delete(walletId);
          this.removePendingOperation(walletId, operationId);
          this.showNotify({ type: "error", message: res.data.message });
        }

        this.getPayerBalance();
      } catch (err) {
        this.activeOperations.delete(walletId);
        this.removePendingOperation(walletId, operationId);
        console.log(err);
        this.showNotify({ type: "error", message: err.response?.data?.message || "Ошибка при покупке" });
      }
    },
    buyToAccountFunction(wallets) {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/buy`,
          {
            walletIds: wallets,
            tokenId: this.selectedToken.id,
            solAmount: this.solAmountBuyRandom,
            slippage: this.slippageBuy,
            jitoTip: this.jitoTip,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          res.data.ok ? this.showNotify({ type: "success", message: res.data.message }) : this.showNotify({ type: "error", message: res.data.message });
          this.getPayerBalance();
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
      // .finally(() => {
      //   // Снимаем pending с выбранных кошельков
      //   const selectedWalletsInfo = this.wallets.filter((w) => wallets.includes(w.id));
      //   selectedWalletsInfo.forEach((wallet) => (wallet.pending = false));
      // });
    },
    async sellTokens() {
      this.isRandomSelect ? this.handlePickWalletRandom("sell") : null;
      if (!this.selectedWallets.length) return this.showNotify({ type: "error", message: "Выберите кошельки для продажи" });

      // Фиксируем состояние при нажатии (чтобы не зависеть от изменений selectedWallets)
      const walletIdsToSell = [...this.selectedWallets];
      const walletsToSell = this.wallets.filter((w) => walletIdsToSell.includes(w.id));

      // Ставим pending = true для тех, что реально идут в запрос
      walletsToSell.forEach((wallet) => (wallet.pendingSell = true));

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/sell`,
          {
            walletIds: walletIdsToSell,
            tokenId: this.selectedToken.id,
            sellPercent: this.sellPercentSell / 100,
            jitoTip: this.jitoTip,
            withReturn: this.withReturn
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );

        console.log(res);
        this.getPayerBalance();
        this.showNotify({ type: "success", message: res.data.message });
      } catch (err) {
        console.error(err);
        this.showNotify({
          type: "error",
          message: err.response?.data?.message || "Ошибка при продаже",
        });
      } finally {
        // Сбрасываем pending только у тех, кто участвовал в запросе
        walletsToSell.forEach((wallet) => (wallet.pendingSell = false));
      }
    },

    redeemSol() {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/create-returns`,
          {
            walletIds: this.selectedWallets,
            tokenId: this.selectedToken.id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          // if (res.data[0].ok) this.toast.success("Success", { timeout: 2000 })
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
    },
    redeemAllSol() {
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/create-returns`,
          {
            walletIds: this.wallets.map((l) => l.id),
            tokenId: this.selectedToken.id,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status == 201) this.showNotify({ type: "success", message: "Success" });
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
    },
    dumpClick() {
      this.sendDump(this.wallets.map((l) => l.id));
    },
    semiDumpClick() {
      // Семидамп: продаём со старших по холдингам кошельков, пока суммарно не наберём ~половину токенов
      const holders = this.wallets
        .map((wallet) => ({ wallet, holdings: this.safeNum(wallet.balanceSpl) }))
        .filter((item) => item.holdings > 0)
        .sort((a, b) => b.holdings - a.holdings);

      if (holders.length === 0) {
        this.showNotify({ type: "error", message: "Нет кошельков с токенами для продажи" });
        return;
      }

      const half = holders.reduce((acc, item) => acc + item.holdings, 0) / 2;

      const selected = [];
      let accumulated = 0;
      for (const item of holders) {
        // если добавление кошелька уводит сумму дальше от половины, чем уже набрано — останавливаемся
        if (selected.length > 0 && Math.abs(accumulated + item.holdings - half) > Math.abs(accumulated - half)) {
          break;
        }
        selected.push(item.wallet);
        accumulated += item.holdings;
        if (accumulated >= half) break;
      }

      this.sendDump(selected.map((l) => l.id));
    },
    sendDump(walletIds) {
      console.log("Запросик");
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/token/sell-dump`,
          {
            walletIds,
            tokenId: this.selectedToken.id,
            sellPercent: 1,
            jitoTip: this.jitoTip,
            rug: true,
            pnl: this.safeNum(this.profitEstimate).toString(),
            rugcount: this.safeNum(this.dumpSum).toString(),
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          console.log("DUMP", res);
          this.showNotify({ type: "success", message: res.data.message });
          // this.getBalances()
        })
        .catch((err) => {
          console.log(err);
          this.showNotify({ type: "error", message: err.response.data.message });
        });
    },
    async getBalances() {
      if (!this.selectedToken?.mintPublicKey || this.wallets.length === 0) {
        this.recalculateTotals();
        this.loadWallets();
        return;
      }

      const headers = {
        Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
      };
      const walletPublicKeys = this.wallets.map((l) => l.publicKey);

      try {
        const [solRes, splRes] = await Promise.all([
          axios.post(
            `${process.env.VUE_APP_SERVERHOST}/api/wallet/sol-balance`,
            {
              walletPublicKeys,
            },
            { headers }
          ),
          axios.post(
            `${process.env.VUE_APP_SERVERHOST}/api/wallet/spl-balance`,
            {
              walletPublicKeys,
              mintPublicKey: this.selectedToken.mintPublicKey,
            },
            { headers }
          ),
        ]);

        const solBalancesByWallet = new Map((solRes.data || []).map((item) => [item.wallet, this.safeNum(item.balance)]));
        const splBalancesByWallet = new Map((splRes.data || []).map((item) => [item.wallet, this.safeNum(item.balance)]));

        this.wallets = this.wallets.map((wallet) => ({
          ...wallet,
          balance: solBalancesByWallet.get(wallet.publicKey) ?? 0,
          balanceSpl: splBalancesByWallet.get(wallet.publicKey) ?? 0,
        }));

        this.recalculateTotals();
        await this.refreshWalletsSellRates();
        this.queueCoreMetricsRefresh();
        this.queueHoldersRefresh();

        setTimeout(async () => {
          await this.loadCreatorFee();
          this.getProfitEstimate();
        }, 6000);
      } catch (err) {
        console.log(err);
      }
    },
    getPayerBalance() {
      if (!this.selectedToken?.payerWallet?.publicKey) {
        return;
      }
      // console.log("Получаю баланс плательщика");
      axios
        .post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/sol-balance`,
          {
            walletPublicKeys: [this.selectedToken.payerWallet.publicKey],
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => {
          this.payerIdBalance = this.safeNum(res.data?.[0]?.balance);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async loadPNL() {
      if (!this.selectedToken?.id || !this.selectedToken?.mintPublicKey) {
        return;
      }
      if (this.isPnlLoading) {
        this.pendingPnlRefresh = true;
        return;
      }

      this.isPnlLoading = true;
      const totalSplBalance = Math.floor(this.safeNum(this.totalSPLBalance));

      try {
        const headers = {
          Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
        };
        const [expensesRes, sellRateRes] = await Promise.all([
          axios.get(`${process.env.VUE_APP_SERVERHOST}/api/token/expenses/${this.selectedToken.id}`, { headers }),
          axios.get(`${process.env.VUE_APP_SERVERHOST}/api/token/sell-rate/${this.selectedToken.mintPublicKey}?count=${totalSplBalance}`, { headers }),
        ]);

        const sellCount = this.safeNum(sellRateRes.data?.count);
        this.PNL1.solanaSum = this.safeNum(expensesRes.data?.solanaSum);
        this.PNL1.totalSPLBalance = this.safeNum(this.totalSPLBalance);
        this.PNL1.count = sellCount;
        this.dumpSum = sellCount;
        this.getProfitEstimate();
      } catch (err) {
        console.log(err);
      } finally {
        this.isPnlLoading = false;
        if (this.pendingPnlRefresh) {
          this.pendingPnlRefresh = false;
          this.loadPNL();
        }
      }
    },
    getWallets(tokenId) {
      axios
        .get(`${process.env.VUE_APP_SERVERHOST}/api/token/${tokenId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        .then((res) => {

          if(res.data) {
            this.selectedToken = res.data;
            this.$store.commit("setSelectedToken", res.data);
          }

          const wallets = Array.isArray(res.data?.wallets) ? res.data.wallets : [];
          this.wallets = wallets;
          this.wallets.forEach((wallet) => {
            wallet.pending = false;
            wallet.pendingSell = false;
          });
          if (typeof this.stopWalletMonitoring === "function") {
            this.stopWalletMonitoring();
          }
          if (this.selectedToken?.mintPublicKey && this.wallets.length > 0) {
            this.stopWalletMonitoring = startMonitoring({ wallets: this.wallets, tokenMint: this.selectedToken.mintPublicKey }, EventBus);
          } else {
            this.stopWalletMonitoring = null;
          }

          const archivedWallets = this.$store.getters.getArchiveWallets(this.selectedToken.id);
          this.archivedWallets = Array.isArray(archivedWallets) ? archivedWallets : [];
          console.log("ARCHIVE", this.archivedWallets, this.wallets);
          const archivedPublicKeys = new Set(this.archivedWallets.map((wallet) => wallet.publicKey));
          this.wallets = this.wallets.filter((wallet) => {
            return !archivedPublicKeys.has(wallet.publicKey);
          });
          // console.log(res, this.$store.state)
          // this.selectedWallets = this.wallets[0]
          this.selectedWalletBuy = this.wallets[0];
          this.selectedWalletSell = this.wallets[0];
          this.photonFee = res.data.photon_percent
          this.photonTradersPercent = res.data.pro_traders_percent 
          this.axiomTradersPercent = res.data.pro_traders_percent_axiom 
          this.bullxTradersPercent = res.data.pro_traders_percent_bullx 
          this.padreTradersPercent = res.data.pro_traders_percent_padre
          this.gmgnTradersPercent = res.data.pro_traders_percent_gmgn

          this.recalculateTotals();
          this.getBalances();
          this.loadWallets();
          this.initVirtualBalances();
          // console.log("WALLETS LOADED")
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getHolders2() {
       /* eslint-disable */
      
      const solana_rate = await axios
        .get(
          `${process.env.VUE_APP_SERVERHOST}/api/token/sell-rate/${this.selectedToken.mintPublicKey}?count=1`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        .then((res) => res.data.count)
        .catch((err) => {
          console.log(err);
          return 0;
        });
      const body = {
        jsonrpc: "2.0",
        id: crypto.randomUUID(),
        method: "getProgramAccountsV2",
        params: [
          TOKEN_2022_PROGRAM_ID.toBase58(),
          {
            encoding: "jsonParsed",
            filters: [
              //{
              //  dataSize: 182,
              //},
              {
                memcmp: {
                  offset: 0,
                  bytes: new PublicKey(this.selectedToken.mintPublicKey).toBase58(),
                },
              },
            ],
            limit: 1000,
          },
        ],
      };

      const res = await axios.post(RPC_ENDPOINT, body, {
        //method: "",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const json = res.data;
      const accounts = json.result?.accounts ?? [];

      const totalSupply = 1_000_000_000;
      const holders = [];

      accounts.forEach(({ pubkey, account }) => {
        const data = account.data
        const accountData = data.parsed
        const balance = Number(accountData.info.tokenAmount.amount);

        if (balance > 0) {
          holders.push({
            address: pubkey,
            owner: new PublicKey(accountData.info.owner).toBase58(),
            balance,
            uiAmount: (balance / 10 ** 6) * solana_rate,
            supplyPercent: (balance / 10 ** 6 / totalSupply) * 100,
          });
        }
      });

      holders.sort((a, b) => b.balance - a.balance);

      const filteredArray = holders
      .filter(
        (item) => !this.wallets.some((wallet) => wallet.publicKey === item.owner)
      );

      this.holders = filteredArray;
    },
    async getHolders() {
      if (!this.selectedToken?.mintPublicKey) {
        return;
      }
      if (this.isHoldersLoading) {
        this.pendingHoldersRefresh = true;
        return;
      }

      this.isHoldersLoading = true;

      try {
        const headers = {
          Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
        };
        const solana_rate = await axios
          .get(`${process.env.VUE_APP_SERVERHOST}/api/token/sell-rate/${this.selectedToken.mintPublicKey}?count=1`, { headers })
          .then((res) => res.data.count)
          .catch((err) => {
            console.log(err);
            return 0;
          });

        const filters = [
          {
            memcmp: {
              offset: 0,
              bytes: new PublicKey(this.selectedToken.mintPublicKey).toBase58(),
            },
          },
          //{
          //  dataSize: 182,
          //},
        ];

        const totalSupply = 1000000000;
        const accounts = await connection.getProgramAccounts(TOKEN_2022_PROGRAM_ID, { filters });
        const holders = [];
        let totalPercent = 0;

        accounts.forEach(({ pubkey, account }) => {
          const accountData = AccountLayout.decode(account.data);
          const balance = Number(accountData.amount);
          if (balance > 0) {
            holders.push({
              address: pubkey.toBase58(),
              owner: new PublicKey(accountData.owner).toBase58(),
              balance,
              uiAmount: (balance / 10 ** 6) * solana_rate,
              supplyPercent: (balance / 10 ** 6 / totalSupply) * 100,
            });
          }
        });

        holders.sort((a, b) => b.balance - a.balance);
        const filteredArray = holders.filter((item) => !this.wallets.some((wallet) => wallet.publicKey === item.owner));
        for (const holder of filteredArray) {
          if (String(holder.owner) !== String(this.tokenBondingCurve)) {
            totalPercent += holder.supplyPercent;
          }
        }
        this.totalHoldersPercent = totalPercent.toFixed(2);
        this.holders = filteredArray;
      } catch (err) {
        console.log(err);
      } finally {
        this.isHoldersLoading = false;
        if (this.pendingHoldersRefresh) {
          this.pendingHoldersRefresh = false;
          this.getHolders();
        }
      }
    },
async loadCreatorFee() {
  const PUMPFUN_PROGRAM_ID = new PublicKey("6EF8rrecthR5Dkzon8Nwu78hRvfCKubJ14M5uBEwF6P");
  const BONDING_CURVE_SEED = Buffer.from("bonding-curve");
  const CREATOR_VAULT_SEED = Buffer.from("creator-vault");

  const formatSol = (lamports) =>
    (Number(lamports) / 1e9).toFixed(9).replace(/\.?0+$/, "");

  const mintPk = new PublicKey(this.selectedToken.mintPublicKey);

  const [bondingCurvePda] = PublicKey.findProgramAddressSync(
    [BONDING_CURVE_SEED, mintPk.toBuffer()],
    PUMPFUN_PROGRAM_ID
  );
  // layout: [8 discriminator] + [5*u64 reserves/supply] + [bool complete] + (optional [bool is_mayhem_mode]) + [32 creator]
  // old: creatorOffset = 8 + 40 + 1 = 49
  // new: creatorOffset = 8 + 40 + 1 + 1 = 50 (bondingCurve size bumped to 82) :contentReference[oaicite:0]{index=0}

  const [creatorVaultPda] = PublicKey.findProgramAddressSync(
    [CREATOR_VAULT_SEED, (new PublicKey(this.selectedToken.devWallet.publicKey)).toBuffer()],
    PUMPFUN_PROGRAM_ID
  );

  const vaultInfo = await connection.getAccountInfo(creatorVaultPda);

  if (!vaultInfo) {
    this.creatorFee = "0";
    return;
  }

  console.log({vaultInfo})

  const rentMin = 0//await connection.getMinimumBalanceForRentExemption(vaultInfo.data.length);
  const withdrawableLamports = BigInt(Math.max(0, vaultInfo.lamports - rentMin));

  this.creatorFee = formatSol(withdrawableLamports);
},
    getTokens() {
      axios
        .get(`${process.env.VUE_APP_SERVERHOST}/api/token/my`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        .then((res) => {
          this.tokens = res.data.reverse();
          
          this.optionsPickToken = this.tokens.map((token) => ({
            name: token.name,
            key: token,
          }));
          this.$store.commit("setTokens", this.optionsPickToken);
          //if(!this.selectedToken) {
          //  this.selectedToken = key;
          //  
          //  console.log("ААААААААААААА", this.$store.getters.getSelectedToken);
          //  window.location.reload();
          //}


          // this.getWallets(this.selectedToken.id)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadWallets() {
      this.optionsPickAccount = this.wallets.map((wallet) => ({
        id: wallet.id,
        key: wallet,
        label: `${wallet.publicKey.slice(0, 3)}...${wallet.publicKey.slice(-3)} ${wallet.balance.toFixed(5)} SOL / ${Number(wallet.count).toFixed(5)} SOL`,
      }));
      // let b  = this.wallets.map(wallet => ({
      //     label: wallet.publicKey.slice(0, 3) + '...' + wallet.publicKey.slice(-3) + " " + wallet.balance.toFixed(4) + " SOL / " + wallet.balanceSpl.toFixed(4) + " " + this.selectedToken.symbol,
      //     id: wallet.id,
      //     key: wallet
      // }))
      this.loadDataInfo();
    },
    async refreshWalletsSellRates() {
      const requests = this.wallets.map((wallet) => this.loadBalanceTokenToSOL(wallet, { silent: true }));
      await Promise.all(requests);
      this.loadWallets();
    },
    async loadBalanceTokenToSOL(wallet, { silent = false } = {}) {
      if (!this.selectedToken?.mintPublicKey) {
        return;
      }

      try {
        const res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/token/sell-rate/${this.selectedToken.mintPublicKey}?count=${Math.floor(this.safeNum(wallet.balanceSpl))}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        });
        const foundWallet = this.wallets.find((w) => w.publicKey === wallet.publicKey);
        if (foundWallet) {
          foundWallet.count = this.safeNum(res.data?.count);
          if (!silent) {
            this.loadWallets();
          }
        } else {
          console.warn("Кошелек не найден");
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkDumpSum() {
      axios
        .get(`${process.env.VUE_APP_SERVERHOST}/api/token/sell-rate/${this.selectedToken.mintPublicKey}?count=${Math.floor(this.totalSPLBalance)}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        .then((res) => {
          this.dumpSum = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async initBumpBot() {
      try {
        let res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/bump/init/${this.selectedToken.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        console.log("INIT BUMP BOT", res);
        this.bumpInitInfo = res.data;
        this.checkBumpBot();
      } catch (err) {
        console.log(err);
      }
    },
    async startBumpBot() {
      try {
        /* eslint-disable */
        let res = await axios.put(
          `${process.env.VUE_APP_SERVERHOST}/api/bump/start/${this.selectedToken.id}`,
          {
            solAmount: this.bumpAmount,
            mode: this.bumpMode,
            burst: this.bumpBurst,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        this.showNotify({ type: "success", message: "Bump Bot successfully started!" });
        this.checkBumpBot();
      } catch (err) {
        console.log(err);
      }
    },
    async stopBumpBot() {
      try {
        /* eslint-disable */
        let res = await axios.put(
          `${process.env.VUE_APP_SERVERHOST}/api/bump/stop/${this.selectedToken.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        this.showNotify({ type: "success", message: "Bump Bot successfully stopped!" });
        this.checkBumpBot();
      } catch (err) {
        console.log(err);
      }
    },
    async checkBumpBot() {
      try {
        let res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/bump/${this.selectedToken.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        });
        this.bumpInfo = res.data;
        console.log("BUMP INFO", this.bumpInfo);
        this.checkBumpBalance();
      } catch (err) {
        console.log(err);
      }
    },
    async checkBumpBalance(event) {
      try {
        let r = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/wallet/sol-balance`,
          {
            walletPublicKeys: [this.bumpInfo.publicKey],
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        );
        // console.log("БАЛАНС БАМПА", r);
        this.bumpBalance = r.data[0].balance;
        if (event?.target?.innerText == "Update") this.showNotify({ type: "success", message: "Balance successfully updated!" });
      } catch (err) {
        console.log("БАЛАНС БАМПА", err);
      }
    },
    async patchToken(data) {
      try {
        console.log('update', data)
        const res = await axios.patch(
          `${process.env.VUE_APP_SERVERHOST}/api/token/${this.selectedToken.id}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          }
        )
        this.getWallets(this.selectedToken.id)
        this.showNotify({ type: "success", message: "Token Config Updated!" });
      } catch (error) {
        
      }
    },
    async handleTokenMigration () {
      if(!this.selectedToken?.pumpamm_migrated && this.tokenBondingCurve) {
        const acc = await connection.getAccountInfo(this.tokenBondingCurve, "processed");
        if(!acc) {return}
        const COMPLETE_OFFSET = 8 + 5 * 8; 
        const complete = acc?.data.length > COMPLETE_OFFSET && acc?.data[COMPLETE_OFFSET] === 1;

        //console.log({ complete })
        
        if(complete) {
          const res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/token/${this.selectedToken.id}`, { headers: { Authorization: `Bearer ${this.$store.getters.getUserData.key}` } })
          
          const tokenData = res.data
          //console.log(tokenData)
          if(!tokenData?.pumpamm_migrated || !tokenData?.pool) {
            await axios.post(`${process.env.VUE_APP_SERVERHOST}/api/token/migrate/${this.selectedToken.id}`, {}, { headers: { Authorization: `Bearer ${this.$store.getters.getUserData.key}` } })
          } else {
            this.selectedToken = res.data;
            this.$store.commit("setSelectedToken", res.data);
          }
        }

       // console.log(this.selectedToken)
      }

    },  
    async loadHistoricalTransactions() {
      try {
        const tokenMint = this.selectedToken.mintPublicKey;
        const history = await fetchPastTransactions(tokenMint, 1000);
        this.transactions = [...history];
      } catch (e) {
        console.error("Ошибка при загрузке истории транзакций:", e);
      }
    },
    setupEventListeners() {
      if (this.eventHandlers.onSolBalanceUpdated) {
        return;
      }

      this.eventHandlers.onSolBalanceUpdated = (payload) => {
        const walletToUpdate = this.wallets.find((w) => w.id === payload.wallet.id);
        if (walletToUpdate) {
          walletToUpdate.balance = this.safeNum(payload.balance);

          const now = Date.now();
          if (this.virtualBalances[walletToUpdate.id]) {
            const oldOperations = this.virtualBalances[walletToUpdate.id].pendingOperations.filter((op) => now - op.timestamp > 30000);
            if (oldOperations.length > 0) {
              this.activeOperations.delete(walletToUpdate.id);
              this.virtualBalances[walletToUpdate.id].pendingOperations = [];
            }
          }
        }

        this.recalculateTotals();
        this.queueCoreMetricsRefresh();
      };

      this.eventHandlers.onTokenBalanceUpdated = (payload) => {
        const walletToUpdate = this.wallets.find((w) => w.id === payload.wallet.id);
        if (walletToUpdate) {
          walletToUpdate.balanceSpl = this.safeNum(payload.balance);

          if (this.safeNum(payload.balance) > 0) {
            this.activeOperations.delete(walletToUpdate.id);
            if (this.virtualBalances[walletToUpdate.id]) {
              this.virtualBalances[walletToUpdate.id].pendingOperations = [];
            }
          }
        }

        this.recalculateTotals();
        this.queueCoreMetricsRefresh();
        this.queueHoldersRefresh();
      };

      this.eventHandlers.onTransaction = (tx) => {
        // Deduplicate by signature
        if (tx.signature && this.transactions.some((t) => t.signature === tx.signature)) {
          return;
        }
        this.transactions.unshift(tx);
        // Cap at 200 entries
        if (this.transactions.length > 200) {
          this.transactions.pop();
        }
      };

      EventBus.on("sol-balance-updated", this.eventHandlers.onSolBalanceUpdated);
      EventBus.on("token-balance-updated", this.eventHandlers.onTokenBalanceUpdated);
      EventBus.on("transaction", this.eventHandlers.onTransaction);
    },
    teardownEventListeners() {
      if (this.eventHandlers.onSolBalanceUpdated) {
        EventBus.off("sol-balance-updated", this.eventHandlers.onSolBalanceUpdated);
      }
      if (this.eventHandlers.onTokenBalanceUpdated) {
        EventBus.off("token-balance-updated", this.eventHandlers.onTokenBalanceUpdated);
      }
      if (this.eventHandlers.onTransaction) {
        EventBus.off("transaction", this.eventHandlers.onTransaction);
      }
      this.eventHandlers.onSolBalanceUpdated = null;
      this.eventHandlers.onTokenBalanceUpdated = null;
      this.eventHandlers.onTransaction = null;
    },
  },
  computed: {
    walletPnL() {
      const ownKeys = new Set((this.wallets || []).map((w) => w.publicKey));
      const map = {};

      for (const tx of this.transactions) {
        if (!map[tx.wallet]) {
          map[tx.wallet] = { wallet: tx.wallet, bought: 0, sold: 0, isOwn: ownKeys.has(tx.wallet) };
        }
        if (tx.type === "buy") {
          map[tx.wallet].bought += Number(tx.sol_amount);
        } else if (tx.type === "sell") {
          map[tx.wallet].sold += Number(tx.sol_amount);
        }
      }

      return Object.values(map)
        .filter((w) => w.bought > 0 && w.sold > 0)
        .map((w) => ({ ...w, pnl: w.sold - w.bought }));
    },
    walletPnLMap() {
      const m = {};
      for (const item of this.walletPnL) {
        m[item.wallet] = item;
      }
      return m;
    },
    usedWallets() {
      const s = new Set();
      for (const tx of this.transactions) {
        s.add(tx.wallet);
      }
      return s;
    },
  },
  watch: {
    withReturn(newValue) {
      persistWithReturn(newValue);
    },
    tradesFilter() {
      // Client-side filtering happens in the template v-for
    },
    "PNL1.count"() {
      this.getProfitEstimate();
    },
    totalSOLBalance() {
      this.getProfitEstimate();
    },
    payerIdBalance() {
      this.getProfitEstimate();
    },
    creatorFee() {
      this.getProfitEstimate();
    },
    "selectedToken.payerSolBalanceOnDeploy"() {
      this.getProfitEstimate();
    },
  },
  async mounted() {
    let els = document.querySelectorAll(".projectComponent");
    if (this.isProject)
      els.forEach((el) => {
        // el.style.flex = "1 1 calc(20% - 10px);"
        el.style.flex = "1 1 calc(20% - 10px)";
      });
    this.selectedToken = this.$store.getters.getSelectedToken;

    this.preHeatedWalletCount = await this.getPreHeatedWalletsCount()
    this.getTokens();
    this.getWallets(this.selectedToken.id);
    try {
      this.tokenBondingCurve = PublicKey.findProgramAddressSync(
        [Buffer.from("bonding-curve"), new PublicKey(this.selectedToken.mintPublicKey).toBuffer()],
        new PublicKey('6EF8rrecthR5Dkzon8Nwu78hRvfCKubJ14M5uBEwF6P')
      )[0];
    } catch (error) {
      
    }

    this.loadCreatorFee();
    this.initBumpBot();
    console.log(this.wallets, "WALLETS");
    this.initSocket();
    this.subscribeToAxiomToken()
    this.setupEventListeners();
    this.loadHistoricalTransactions();
    this.holdersIntervalId = setInterval(() => {
      this.queueHoldersRefresh();
    }, 2000);
    this.interval = this.holdersIntervalId;
    this.migrationIntervalId = setInterval(() => {
      this.handleTokenMigration();
    }, 2000);
    this.getPadreEyesInfo()
    this.activeOperationsIntervalId = setInterval(() => {
      const now = Date.now();

      this.activeOperations.forEach((walletId) => {
        if (this.virtualBalances[walletId]) {
          const hasOldOperations = this.virtualBalances[walletId].pendingOperations.some(
            (op) => now - op.timestamp > 5000 // 30 секунд
          );

          if (hasOldOperations) {
            this.activeOperations.delete(walletId);
            this.virtualBalances[walletId].pendingOperations = [];
            console.log(`Очищен зависший кошелек: ${walletId}`);
          }
        }
      });
    }, 5000);
    this.documentClickHandler = (event) => {
      if (!event.target.closest(".context-menu")) {
        this.closeContextMenu();
      }
    };
    document.addEventListener("click", this.documentClickHandler);
  },
  beforeUnmount() {
    if (this.holdersIntervalId) clearInterval(this.holdersIntervalId);
    if (this.lastTransactionsIntervalId) clearInterval(this.lastTransactionsIntervalId);
    if (this.migrationIntervalId) clearInterval(this.migrationIntervalId);
    if (this.activeOperationsIntervalId) clearInterval(this.activeOperationsIntervalId);
    if (this.coreMetricsRefreshTimeoutId) clearTimeout(this.coreMetricsRefreshTimeoutId);
    if (this.holdersRefreshTimeoutId) clearTimeout(this.holdersRefreshTimeoutId);

    this.interval = null;
    this.holdersIntervalId = null;
    this.lastTransactionsIntervalId = null;
    this.migrationIntervalId = null;
    this.activeOperationsIntervalId = null;

    if (this.documentClickHandler) {
      document.removeEventListener("click", this.documentClickHandler);
      this.documentClickHandler = null;
    }

    this.teardownEventListeners();

    if (typeof this.stopWalletMonitoring === "function") {
      this.stopWalletMonitoring();
      this.stopWalletMonitoring = null;
    }

    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  },
  setup() {
    const toast = useToast();
    const file = ref(null);
    const fileList = ref([]); // Список файлов для UI
    const handeUploadFileComment = ({ file: uploadedFile, onFinish }) => {
      file.value = uploadedFile.file; // Сохраняем файл
      fileList.value = [{ id: Date.now(), name: uploadedFile.file.name }]; // Для UI
      console.log(file.value);
      onFinish(); // Уведомляем Naive UI, что загрузка завершена
    };
    const clearFile = () => {
      file.value = null;
    };
    return {
      toast,
      formatTooltip: (value) => `${Math.floor(value * 100)}%`,
      file,
      handeUploadFileComment,
      clearFile,
    };
  },
};
</script>
<style scoped>
.notify_status img {
  width: 30px;
}
.notifications_list {
  display: flex;
  max-height: 30rem;
  overflow-y: auto;
  flex-direction: column;
}
.notify {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #71db9930;
  padding: 0.5rem;
}
.notify_text {
  text-align: left;
}
.notify:last-child {
  border: none;
}
span.notify_time {
  margin-left: auto;
}
.projects {
  padding: 1%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.project {
  height: fit-content;
  gap: 15px;
  width: 100%;
  /* height: 100vh; */
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr 2fr;
}
.project.bottom {
  grid-template-columns: 1fr 1fr 1fr;
}
.project_block {
  background-color: rgba(0, 0, 0, 0.23);
  border: 3px solid #171717;
  border-radius: 20px;
  padding: 15px;
  text-align: left;
}
.project_under_blocks {
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
}
.project_block_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  gap: 15px;
  position: relative;
}
.project_block_header span {
  font-family: "Proxima Nova Bold";
  font-size: 20px;
}
.spread_bump_head {
  display: flex;
  align-items: center;
  gap: 5px;
}
.spread_bump_head button {
  padding: 5px;
  margin-top: 0;
}
.spread_bump_head .input input {
  width: 100px;
}
.add_wallet {
  background-color: #60cb89;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.add_wallet span {
  transition: all 0.3s;
  user-select: none;
}
.add_wallet_modal {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #171717;
  border-radius: 5px;
  padding: 10px;
  outline: 1px solid #60cb89;
  z-index: 5;
}
.project_block_wallets {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 12px;
}
.project_block_wallet {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #365c44;
  border-radius: 5px;
  padding: 6px 1px;
  cursor: pointer;
  min-height: 40px;
}
.archive_wallets_block {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}
.project_block_wallet.selected {
  outline: 2px solid #60cb89;
}
.project_block_wallet.random {
  outline: 2px solid white;
  outline-offset: -2px;
}
.project_block_wallet span {
  font-size: 12px;
  color: rgba(239, 239, 239, 0.885);
  letter-spacing: 0.2px;
  text-align: center;
  user-select: none;
}
.project_block_wallet span:nth-child(1) {
  font-family: "Proxima Nova Bold";
  margin-top: 0;
}
.project_block_wallet span:nth-child(3) {
  margin-bottom: -5px;
}
.zeroblock-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-left: 3px;
  border-radius: 50%;
  background-color: #5a5a5a;
  color: #fff;
  font-size: 9px !important;
  font-family: 'Proxima Nova Bold' !important;
  line-height: 1;
  flex-shrink: 0;
}
.input {
  background: transparent;
  border: 1px solid #60cb89;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input.medium {
  padding: 10px;
}
.input span {
  font-size: 12px !important;
}
input {
  background-color: transparent;
  outline: none;
  border: none;
  color: white;
  height: 100%;
  width: 100%;
}
.jito_tip {
  position: relative;
  display: flex;
  gap: 15px;
  align-items: center;
}
.jito_tip img {
  width: 25px;
  height: 25px;
}
.jito_tip_text {
  position: absolute;
  left: 15px;
  bottom: 70%;
  font-size: 12px !important;
  background-color: #1d1d1d;
  padding: 0 5px;
}
.project_block_finance {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}
.sell_block {
  display: flex;
  justify-content: space-between;
}
.project_block_mini_header {
  font-size: 16px;
  font-family: "Proxima Nova Bold";
}
.secondary_text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.59);
}
.placeholder_buy {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.buy_placeholder_block {
  background-color: #60cb89;
  border-radius: 5px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
}
.button {
  background-color: #60cb89;
  color: white;
  border-radius: 5px;
  padding: 7px 30px;
  width: fit-content;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all;
  user-select: none;
}
.button:hover {
  background-color: #42a368;
}
.buttons_bump_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.buttons {
  display: flex;
  gap: 8px;
  position: relative;
}
.loader {
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid #60cb89;
  width: 100%;
  margin-top: 5px;
}
.loader-fill {
  background: #60cb80;
  height: 100%;
  border-radius: 5px;
  animation: loading 8s forwards;
}
@keyframes loading {
  0% {
    width: 0%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
.multi-select {
  display: flex;
  gap: 5px;
}
.multi-select img {
  width: 70%;
  height: 70%;
}
.select_all {
  padding: 6px 4px;
  height: fit-content;
  border-radius: 5px;
  background: #60cb89;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
textarea {
  border: 1px solid #60cb89;
  border-radius: 5px;
  background: transparent;
  resize: none;
  color: white;
  height: 100px;
  font-family: "Proxima Nova";
  outline: none;
  padding: 5px;
}
.select_token {
  border: 1px solid #60cb89;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all;
  cursor: pointer;
  position: relative;
}
.select_token:hover {
  background-color: #60cb89;
}
.select_token:hover svg path,
.select_token:hover svg circle {
  stroke: white;
}
.custom-dropdown {
  opacity: 0;
  transform: translateY(-10px);
  visibility: hidden;
  position: absolute;
  top: 100%;
  right: 0;
  background: #262626;
  border: 1px solid #60cb89;
  border-radius: 5px;
  z-index: 10;
  min-width: 200px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.select_token:hover .custom-dropdown {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

.custom-dropdown .item {
  padding: 8px 12px;
  cursor: pointer;
}

.custom-dropdown .item:hover {
  background-color: #363636;
}
.link_pumpfun {
  display: flex;
  align-items: center;
}
.link_axiom {
  display: flex;
  align-items: center;
}
.project_data {
  display: flex;
  gap: 16px;
  max-width: 600px;
}

.info-labels {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 8px;
  align-items: center;
}
.info-labels-bold {
  font-weight: 700;
}

.divider {
  width: 1px;
  background-color: #ddd;
}
.upload_photo_block {
  display: flex;
  justify-content: space-between;
}
.upload_photo {
  background: rgba(96, 203, 137, 0.73);
  border-radius: 7px;
  position: relative;
  padding: 6px 15px;
  font-size: 14px;
  width: fit-content;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload_input {
  display: none;
}
.infoWallets {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  text-align: left;
  font-size: 12px;
  gap: 5px;
  border-bottom: 1px solid #60cb8943;
  padding: 10px 0;
}
.rotatePlus {
  transform: rotate(45deg);
  height: 21px;
}
.multiselect_tag {
  background-color: #41b883;
  border-radius: 5px;
  padding: 2px;
  color: white;
  margin-right: 3px;
}
.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Скрыть стандартный чекбокс */
.ios-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Стиль слайдера */
.ios-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.ios-switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.ios-switch .slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* Когда чекбокс активен, круг двигается направо и меняется цвет */
.ios-switch input:checked + .slider {
  background-color: #62bf8f; /* Зелёный цвет как у iOS */
}

.ios-switch input:checked + .slider:before {
  transform: translateX(20px);
}
.edit_template_buy {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  position: absolute;
  top: 110%;
  right: 0;
  padding: 10px;
  background: #262626;
  border: 1px solid #60cb89;
  border-radius: 5px;
  gap: 5px;
}
.edit_template_buy button {
  background: transparent;
  border: 1px solid #60cb89;
  border-radius: 5px;
}
.edit_template_buy input {
  text-align: center;
}
.trades_filter {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}
.trades_filter p,
.trades_filter .ios-switch,
.trades_filter .button {
  flex-shrink: 0;
}
.notifications_wrapper {
  position: fixed;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000b3;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notifications_block {
  background: #1d1d1d;
  width: 30rem;
  border-radius: 0.8rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.notifications_header {
  font-family: "Proxima Nova Bold";
  font-size: 20px;
}
@media (max-width: 1500px) {
  .project_block_wallets {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (max-width: 1280px) {
  .project {
    gap: 5px;
  }
}
@media (max-width: 1260px) {
  .project_block {
    width: 100%;
  }
  .project_under_blocks {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .project {
    grid-template-columns: 2fr 1fr 1fr;
  }
}
.wallet-yellow {
  background-color: #79782e !important;
}
.wallet-red {
  background-color: #792e2e !important;
}
.wallet-unused {
  outline: 2px solid #b159ff !important;
  outline-offset: -2px;
}
.sub_wallets_block {
  display: flex;
  gap: 1rem;
}
.inputs {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
.heatlogs_table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px; /* Отступ от заголовка */
}

.heatlogs_table th,
.heatlogs_table td {
  border: 1px solid #60cb89;
  padding: 8px;
  text-align: left;
  font-size: 12px; /* Уменьшаем размер шрифта для компактности */
}

.heatlogs_table th {
  background-color: rgba(96, 203, 137, 0.1); /* Лёгкий фон для заголовков */
}

.heatlogs_table tbody tr:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.05); /* Четные строки с фоном */
}

.heatlogs_list {
  max-height: 400px; /* Ограничиваем высоту списка */
  overflow-y: auto; /* Добавляем прокрутку */
}
.context-menu {
  position: absolute;
  background: #262626;
  border: 1px solid #60cb89;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 8px;
  z-index: 1000;
}

.context-menu button {
  display: block;
  width: 100%;
  padding: 6px 12px;
  margin: 4px 0;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background: transparent;
  color: white;
  border: 1px solid #60cb8957;
}
.context-menu button:hover {
  background: #60cb8957;
}

.buttons_bump_block button {
    padding: 7px 20px !important;
}

#dexscreener-embed {
  position:relative;
  width:100%;
  padding-bottom:125%;
} 
@media(min-width:1400px) {
  /*#dexscreener-embed{padding-bottom:65%;}*/
}
#dexscreener-embed iframe {
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  border:0;
}
</style>

